// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-content .cls-1{fill:rgba(46,160,220,0.15)}.empty-content .cls-2{fill:#040849}.empty-content .cls-3,.empty-content .cls-7{fill:#b2b2b2}.empty-content .cls-3{stroke:#d8e9f6}.empty-content .cls-3,.empty-content .cls-5,.empty-content .cls-6,.empty-content .cls-7{stroke-miterlimit:10}.empty-content .cls-4{fill:#d8e9f6}.empty-content .cls-5,.empty-content .cls-6{fill:none;stroke:#040849}.empty-content .cls-6{stroke-width:0.7px}.empty-content .cls-7{stroke:#030748}\n", ""]);
// Exports
module.exports = exports;
